<template>
  <div :class="['filter-panel', layoutClass]">
    <slot name="filters" />
    <div class="filter-actions mt-1" v-if="showActions">
      <b-button variant="secondary" size="sm" @click="$emit('clear')">Clear</b-button>
      <b-button variant="secondary" size="sm" class="ml-2" @click="$emit('apply')">Filter</b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FilterPanel',
  props: {
    mode: {
      type: String,
      default: 'responsive', // 'column' or 'responsive'
    },
    showActions: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    layoutClass() {
      return this.mode === 'column' ? 'vertical' : 'grid';
    },
  },
};
</script>

<style scoped>
.filter-panel.vertical {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.filter-panel.grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* 2 kolone fiksno */
  gap: 1rem;
}
@media (max-width: 768px) {
  .filter-panel.grid {
    grid-template-columns: 1fr;
  }
}
.filter-actions {
  display: flex;
  justify-content: flex-start;
}
</style>
